import { config } from "@nova/configuration/browser"
import LightMapStyleJSON from "./light"
import SatelliteMapStyleJSON from "./satellite"
import WhiteMapStyleJSON from "./white"
import DarkMapStyleJSON from "./dark"
import { DistanceUnit } from "@nova/constants"
import { StyleSpecification } from "maplibre-gl"

export function getUnitAdjustedStyleJSON(mapTheme: StyleSpecification & { id: string }) {
    const organizationSettingDistance = config.get("organizationSettingDistance")
    const sourceLayer = organizationSettingDistance === DistanceUnit.Feet ? "contour_ft" : "contour"
    return {
        ...mapTheme,
        layers: mapTheme.layers.map((layer) => {
            if (!("source-layer" in layer) || !layer["source-layer"]?.includes("contour")) {
                return layer
            }
            return {
                ...layer,
                "source-layer": sourceLayer,
            }
        }),
    }
}

export const mapThemes = {
    light: LightMapStyleJSON,
    satellite: SatelliteMapStyleJSON,
    white: WhiteMapStyleJSON,
    dark: DarkMapStyleJSON,
}
